(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40],{

/***/ 73061:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 96040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(87344);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11699);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78840);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(highcharts__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75708);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75111);
/* harmony import */ var highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_first__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8804);
/* harmony import */ var lodash_first__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_first__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73061);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_last__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71637);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89802);
/* harmony import */ var _components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46400);
/* harmony import */ var _components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69443);
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12597);
/* harmony import */ var _fp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96019);
/* harmony import */ var _api_supply_over_time__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99851);
/* harmony import */ var _hardforks_london__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69857);
/* harmony import */ var _hardforks_paris__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(62105);
/* harmony import */ var _TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62925);
/* harmony import */ var _UpdatedAgo__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2477);




















// Somehow resolves an error thrown by the annotation lib
if (true) {
    // Initialize highchats annotations module (only on browser, doesn't work on server)
    highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
}
const SUPPLY_SINCE_MERGE_SERIES_ID = "supply-since-merge-series";
const SUPPLY_SINCE_MERGE_POW_SERIES_ID = "supply-since-merge-pow-series";
const BITCOIN_SUPPLY_ID = "bitcoin-supply-since-merge-series";
const baseOptions = {
    accessibility: {
        enabled: false
    },
    chart: {
        marginLeft: 0,
        marginRight: 72,
        marginTop: 10,
        backgroundColor: "transparent",
        showAxes: false,
        zooming: {
            type: "x",
            resetButton: {
                position: {
                    x: 0,
                    y: 10
                },
                theme: {
                    fill: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus600 */ .Z.slateus600,
                    style: {
                        opacity: 0.8,
                        fontSize: "12",
                        fontFamily: "Inter",
                        fontWeight: "300",
                        color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].white */ .Z.white,
                        textTransform: "lowercase",
                        border: "1px solid ".concat(_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400)
                    },
                    r: 4,
                    states: {
                        hover: {
                            fill: "#343C56"
                        }
                    }
                }
            }
        }
    },
    title: undefined,
    yAxis: {
        title: {
            text: undefined
        },
        labels: {
            enabled: true
        },
        gridLineWidth: 0
    },
    xAxis: {
        type: "datetime",
        lineWidth: 0,
        labels: {
            style: {
                color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400
            },
            enabled: false
        },
        tickWidth: 0,
        minPadding: 0.06,
        maxPadding: 0.06
    },
    legend: {
        enabled: true,
        useHTML: true,
        symbolWidth: 0,
        labelFormatter: function() {
            const color = this.visible === false ? "bg-slateus-400 opacity-60" : this.index === 0 ? "bg-[#62A2F3]" : this.index === 1 ? "bg-[#FF891D]" : "bg-[#DEE2F1]";
            return '\n        <div class="flex flex-row gap-x-2 items-center">\n          <div class="w-2 h-2 '.concat(color, ' rounded-full"></div>\n          <div class="\n            text-xs font-normal font-roboto text-slateus-200\n            ').concat(this.visible ? "" : "opacity-60", '\n          ">\n            ').concat(this.name, "\n          </div>\n        </div>\n      ");
        }
    },
    tooltip: {
        backgroundColor: "transparent",
        useHTML: true,
        borderWidth: 4,
        shadow: false
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        series: {
            marker: {
                lineColor: "white",
                radius: 3,
                symbol: "circle"
            }
        }
    }
};
const getTooltip = (type, series, pointMap)=>// This part is a mess, feel free to refactor heavily.
    function() {
        if (series === undefined || pointMap === undefined) {
            return "";
        }
        const x = typeof this.x === "number" ? this.x : undefined;
        if (x === undefined) {
            return "";
        }
        const firstPoint = lodash_first__WEBPACK_IMPORTED_MODULE_4___default()(series);
        if (firstPoint === undefined) {
            return "";
        }
        const firstSupply = firstPoint[1];
        const total = pointMap[x];
        if (total === undefined) {
            return "";
        }
        // const totalUsd = total * ethPrice;
        // const totalFormatted =
        //   type === "bitcoin"
        //     ? formatTwoDigit(total)
        //     : unit === "eth"
        //     ? formatTwoDigit(total)
        //     : unit === "usd"
        //     ? formatZeroDecimals(total)
        //     : (undefined as never);
        const totalFormatted = (0,_format__WEBPACK_IMPORTED_MODULE_12__/* .formatTwoDigit */ .cI)(total);
        const formattedTotalUnit = type === "bitcoin" ? "BTC" : "ETH";
        const dt = new Date(x);
        const formattedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(dt, "iii MMM dd yyyy");
        const formattedTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(dt, "HH:mm:ss 'UTC'x");
        const title = type === "pos" ? "ETH" : type === "pow" ? "ETH (PoW)" : "BTC";
        const formattedDeltaUnit = type === "bitcoin" ? "BTC" : "ETH";
        const nativeDelta = total - firstSupply;
        const supplyDeltaFormatted = nativeDelta === undefined ? undefined : (0,_format__WEBPACK_IMPORTED_MODULE_12__/* .formatTwoDecimalsSigned */ ._K)(nativeDelta);
        const gradientCss = nativeDelta !== undefined && nativeDelta <= 0 ? "from-orange-400 to-yellow-300" : "from-cyan-300 to-indigo-500";
        // const supplyDeltaPercent =
        //   nativeDelta === undefined
        //     ? undefined
        //     : type !== "bitcoin" && unit === "usd"
        //     ? formatPercentFiveDecimalsSigned(deltaUsd / totalUsd)
        //     : formatPercentFiveDecimalsSigned(nativeDelta / total);
        const supplyDeltaPercent = (0,_format__WEBPACK_IMPORTED_MODULE_12__/* .formatPercentFiveDecimalsSigned */ .cU)(nativeDelta / total);
        // z-10 does not work without adjusting position to !static.
        return '\n      <div class="relative z-10 p-4 rounded-lg border-2 font-roboto bg-slateus-700 border-slateus-400">\n        <div class="mb-2 text-slateus-200">'.concat(title, '</div>\n        <div class="text-right text-slateus-200">').concat(formattedDate, '</div>\n        <div class="text-right text-slateus-200">').concat(formattedTime, '</div>\n        <div class="flex flex-col items-end mt-2">\n          <div class="text-white">\n            ').concat(totalFormatted, '\n            <span class="text-slateus-200"> ').concat(formattedTotalUnit, '</span>\n          </div>\n          <div class="\n            text-transparent bg-clip-text bg-gradient-to-r\n            ').concat(gradientCss, "\n            ").concat(nativeDelta === undefined ? "hidden" : "", '\n          ">\n            ').concat(supplyDeltaFormatted, '\n            <span class="text-slateus-200"> ').concat(formattedDeltaUnit, '</span>\n          </div>\n          <div class="\n            text-transparent bg-clip-text bg-gradient-to-r\n            ').concat(gradientCss, "\n            ").concat(supplyDeltaPercent === undefined ? "hidden" : "", '\n          ">\n            (').concat(supplyDeltaPercent, ")\n          </div>\n        </div>\n      </div>\n    ");
    };
const YEAR_IN_SECONDS = 365.25 * 24 * 60 * 60;
const getSupplyChangeLabel = (points)=>function() {
        const firstPoint = lodash_first__WEBPACK_IMPORTED_MODULE_4___default()(points);
        const lastPoint = lodash_last__WEBPACK_IMPORTED_MODULE_5___default()(points);
        if (firstPoint === undefined || lastPoint === undefined) {
            return "";
        }
        const secondsDelta = (0,date_fns__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(lastPoint[0], firstPoint[0]);
        const supplyDelta = lastPoint[1] - firstPoint[1];
        const yearlyDelta = supplyDelta / secondsDelta * YEAR_IN_SECONDS;
        const yearlySupplyDeltaPercent = (0,_format__WEBPACK_IMPORTED_MODULE_12__/* .formatPercentThreeDecimalsSigned */ .Xx)(yearlyDelta / firstPoint[1]);
        return '\n      <span class="text-xs font-normal font-roboto text-slateus-400">\n        <span class="text-white">'.concat(yearlySupplyDeltaPercent, "</span>/y\n      </span>\n    ");
    };
const deltaLegendLableStyle = {
    fontSize: "12",
    fontFamily: "Roboto mono",
    fontWeight: "300",
    color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400
};
const optionsFromSupplySeriesCollection = (supplySeriesCollection, timeFrame, posVisible, powVisible, btcVisible, onPosVisibilityChange, onPowVisibilityChange, onBtcVisibilityChange)=>{
    var ref;
    const { posSeries , powSeries , btcSeriesScaled , btcSeries  } = supplySeriesCollection;
    const lastPointPos = lodash_last__WEBPACK_IMPORTED_MODULE_5___default()(posSeries);
    const lastPointPow = lodash_last__WEBPACK_IMPORTED_MODULE_5___default()(powSeries);
    const lastPointBtc = lodash_last__WEBPACK_IMPORTED_MODULE_5___default()(btcSeriesScaled);
    const ethPosPointMap = Object.fromEntries(new Map(posSeries !== null && posSeries !== void 0 ? posSeries : []).entries());
    const ethPowPointMap = Object.fromEntries(new Map(powSeries !== null && powSeries !== void 0 ? powSeries : []).entries());
    const bitcoinPointMap = Object.fromEntries(new Map(btcSeries !== null && btcSeries !== void 0 ? btcSeries : []).entries());
    const dynamicOptions = {
        legend: {
            enabled: true
        },
        yAxis: {
            plotLines: [
                {
                    id: "supply-at-start",
                    value: posSeries === null || posSeries === void 0 ? void 0 : (ref = posSeries[0]) === null || ref === void 0 ? void 0 : ref[1],
                    color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400,
                    width: 1,
                    label: {
                        x: 32,
                        y: 4,
                        style: {
                            color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400
                        }
                    }
                },
                {
                    id: "bitcoin-issuance",
                    value: lastPointBtc === undefined ? undefined : lastPointBtc[1],
                    width: 0,
                    label: {
                        style: deltaLegendLableStyle,
                        align: "right",
                        x: 72,
                        y: timeFrame === "since_burn" ? -6 : 2,
                        useHTML: true,
                        formatter: btcSeries === undefined || !btcVisible ? undefined : getSupplyChangeLabel(btcSeries)
                    }
                },
                {
                    id: "eth-issuance-pos",
                    value: lastPointPos === undefined || !posVisible ? undefined : lastPointPos[1],
                    width: 0,
                    label: {
                        style: deltaLegendLableStyle,
                        align: "right",
                        x: 72,
                        y: timeFrame === "since_burn" ? 8 : 2,
                        useHTML: true,
                        formatter: posSeries === undefined ? undefined : getSupplyChangeLabel(posSeries)
                    }
                },
                {
                    id: "eth-issuance-pow",
                    value: lastPointPow === undefined || !powVisible ? undefined : lastPointPow[1],
                    width: 0,
                    label: {
                        style: deltaLegendLableStyle,
                        align: "right",
                        x: 72,
                        y: 2,
                        useHTML: true,
                        formatter: powSeries === undefined ? undefined : getSupplyChangeLabel(powSeries)
                    }
                }
            ]
        },
        xAxis: {
            plotLines: [
                {
                    id: "merge-plotline",
                    value: _hardforks_paris__WEBPACK_IMPORTED_MODULE_16__/* .MERGE_TIMESTAMP.getTime */ .Hc.getTime(),
                    color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400,
                    width: 1,
                    label: {
                        x: 10,
                        y: 4,
                        style: {
                            color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400
                        },
                        useHTML: true,
                        formatter: ()=>'\n                <div class="flex gap-x-2">\n                  <img\n                    class="w-4 h-4 -rotate-90"\n                    src="/panda-own.svg"\n                  />\n                  <a class="rounded-sm hover:underline" href="https://etherscan.io/block/15537394" target="_blank">\n                    <div class="text-xs font-light tracking-widest uppercase font-inter text-slateus-400">\n                      merge\n                    </div>\n                  </a>\n                </div>\n              '
                    }
                },
                {
                    id: "burn-plotline",
                    value: _hardforks_london__WEBPACK_IMPORTED_MODULE_15__/* .LONDON_TIMESTAMP.getTime */ .P.getTime(),
                    color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400,
                    width: 1,
                    label: {
                        x: 10,
                        y: 4,
                        style: {
                            color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus400 */ .Z.slateus400
                        },
                        useHTML: true,
                        formatter: ()=>'\n                <div class="flex gap-x-2">\n                  <img\n                    class="w-4 h-4 -rotate-90"\n                    src="/fire-own.svg"\n                  />\n                  <a class="hover:underline" href="https://etherscan.io/block/12965000" target="_blank">\n                    <div class="text-xs font-light tracking-widest uppercase font-inter text-slateus-400">\n                      burn\n                    </div>\n                  </a>\n                </div>\n              '
                    }
                }
            ]
        },
        series: [
            {
                id: SUPPLY_SINCE_MERGE_SERIES_ID,
                type: "spline",
                name: "ETH",
                visible: posVisible,
                events: {
                    legendItemClick: function() {
                        onPosVisibilityChange((visible)=>!visible);
                    }
                },
                data: lastPointPos === undefined ? posSeries : [
                    ...posSeries,
                    {
                        x: lastPointPos[0],
                        y: lastPointPos[1],
                        marker: {
                            symbol: "url(/graph-dot-blue.svg)",
                            enabled: true
                        }
                    }
                ],
                shadow: {
                    color: "rgba(75, 144, 219, 0.2)",
                    width: 15
                },
                color: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 1,
                        y2: 0
                    },
                    stops: [
                        [
                            0,
                            "#00FFFB"
                        ],
                        [
                            1,
                            "#5487F4"
                        ]
                    ]
                },
                tooltip: {
                    pointFormatter: getTooltip("pos", posSeries, ethPosPointMap)
                },
                zIndex: 2
            },
            {
                color: "#FF891D",
                visible: btcVisible,
                id: BITCOIN_SUPPLY_ID,
                type: "spline",
                shadow: {
                    color: "#FF891D33",
                    width: 15
                },
                events: {
                    legendItemClick: function() {
                        onBtcVisibilityChange((visible)=>!visible);
                    }
                },
                data: btcSeriesScaled === undefined ? undefined : lastPointBtc === undefined ? btcSeriesScaled : [
                    ...btcSeriesScaled,
                    {
                        x: lastPointBtc[0],
                        y: lastPointBtc[1],
                        marker: {
                            symbol: "url(/graph-dot-bitcoin.svg)",
                            enabled: true
                        }
                    }
                ],
                name: "BTC",
                showInLegend: true,
                tooltip: {
                    pointFormatter: getTooltip("bitcoin", btcSeries, bitcoinPointMap)
                },
                zIndex: 1
            },
            {
                color: _colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].slateus100 */ .Z.slateus100,
                visible: powVisible,
                id: SUPPLY_SINCE_MERGE_POW_SERIES_ID,
                name: "ETH (PoW)",
                showInLegend: true,
                type: "spline",
                events: {
                    legendItemClick: function() {
                        onPowVisibilityChange((visible)=>!visible);
                    }
                },
                data: powSeries === undefined ? undefined : lastPointPow === undefined ? powSeries : [
                    ...powSeries,
                    {
                        x: lastPointPow[0],
                        y: lastPointPow[1],
                        marker: {
                            symbol: "url(/graph-dot-white.svg)",
                            enabled: true
                        }
                    }
                ],
                tooltip: {
                    pointFormatter: getTooltip("pow", // Since burn is a special case. Simulating added proof-of-work
                    // from the London hardfork doesn't make sense. It only makes sense
                    // to simulate from the merge. This means that the first point in the
                    // proof-of-work series is not the point to calculate the delta
                    // against. Instead, in that one case, we should use the first point
                    // in the proof-of-stake series.
                    timeFrame === "since_burn" && posSeries.length > 0 ? [
                        posSeries[0],
                        ...powSeries
                    ] : powSeries, ethPowPointMap)
                },
                zIndex: 0,
                shadow: {
                    color: "#DEE2F133",
                    width: 15
                }
            }
        ],
        tooltip: {
            backgroundColor: "transparent",
            borderWidth: 0,
            shadow: false,
            headerFormat: ""
        }
    };
    return lodash_merge__WEBPACK_IMPORTED_MODULE_6___default()({}, baseOptions, dynamicOptions);
};
const updatedAtFromSupplySeriesCollection = (supplySeriesCollections, timeFrame)=>(0,_fp__WEBPACK_IMPORTED_MODULE_13__/* .pipe */ .zG)(supplySeriesCollections, _fp__WEBPACK_IMPORTED_MODULE_13__.O.chain((supplySeriesCollections)=>_fp__WEBPACK_IMPORTED_MODULE_13__.O.fromNullable(supplySeriesCollections[timeFrame])), _fp__WEBPACK_IMPORTED_MODULE_13__.O.map((supplySeriesCollection)=>supplySeriesCollection.timestamp), _fp__WEBPACK_IMPORTED_MODULE_13__.O.toUndefined);
const EthSupplyWidget = (param)=>{
    let { onClickTimeFrame , simulateProofOfWork , timeFrame  } = param;
    const [posVisible, setPosVisible] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true);
    const [powVisible, setPowVisible] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(simulateProofOfWork);
    const [btcVisible, setBtcVisible] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const supplySeriesCollections = (0,_api_supply_over_time__WEBPACK_IMPORTED_MODULE_14__/* .useSupplySeriesCollections */ .It)();
    const hasSeriesData = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(()=>(0,_fp__WEBPACK_IMPORTED_MODULE_13__/* .pipe */ .zG)(supplySeriesCollections, _fp__WEBPACK_IMPORTED_MODULE_13__.O.chain((supplySeriesCollections)=>_fp__WEBPACK_IMPORTED_MODULE_13__.O.fromNullable(supplySeriesCollections[timeFrame])), _fp__WEBPACK_IMPORTED_MODULE_13__.O.map((supplySeriesCollection)=>supplySeriesCollection.posSeries), _fp__WEBPACK_IMPORTED_MODULE_13__.O.map((series)=>series.length > 0), _fp__WEBPACK_IMPORTED_MODULE_13__.O.getOrElse(()=>false)), [
        supplySeriesCollections,
        timeFrame
    ]);
    // Override whatever the current visibility is of the ETH PoW series to make it mirror whatever the user just set the simulateProofOfWork toggle to.
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(()=>{
        setPowVisible(simulateProofOfWork);
    }, [
        simulateProofOfWork
    ]);
    const options = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(()=>(0,_fp__WEBPACK_IMPORTED_MODULE_13__/* .pipe */ .zG)(supplySeriesCollections, _fp__WEBPACK_IMPORTED_MODULE_13__.O.chain((supplySeriesCollections)=>_fp__WEBPACK_IMPORTED_MODULE_13__.O.fromNullable(supplySeriesCollections[timeFrame])), _fp__WEBPACK_IMPORTED_MODULE_13__.O.map((supplySeriesCollection)=>optionsFromSupplySeriesCollection(supplySeriesCollection, timeFrame, posVisible, powVisible, btcVisible, setPosVisible, setPowVisible, setBtcVisible)), _fp__WEBPACK_IMPORTED_MODULE_13__.O.getOrElse(()=>baseOptions)), [
        btcVisible,
        posVisible,
        powVisible,
        supplySeriesCollections,
        timeFrame
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        title: "eth supply",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_11__/* .WidgetBackground */ .K, {
            className: "relative flex h-full min-h-full w-full flex-col lg:h-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pointer-events-none absolute top-0 right-0 bottom-0 left-0 overflow-hidden rounded-lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        // will-change-transform is critical for mobile performance of
                        // rendering the chart overlayed on this element.
                        className: "\n              absolute\n              -left-[64px] -top-[64px]\n              h-full\n              w-full opacity-[0.20]\n              blur-[120px]\n              will-change-transform\n              md:-left-[128px]\n            ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "\n                absolute h-3/5\n                w-4/5 rounded-[35%] bg-[#0037FA]\n                lg:bottom-[3.0rem]\n                lg:-right-[1.0rem]\n              "
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: "flex items-center",
                            children: "eth supply"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            onClickTimeFrame: onClickTimeFrame,
                            timeFrame: timeFrame
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    // flex-grow fixes bug where highcharts doesn't take full width.
                    className: "\n            mt-4 flex h-full\n            w-full select-none\n            justify-center\n            overflow-hidden\n            [&>div]:flex-grow\n          ",
                    children: (0,_fp__WEBPACK_IMPORTED_MODULE_13__/* .pipe */ .zG)(supplySeriesCollections, _fp__WEBPACK_IMPORTED_MODULE_13__.O.match(()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex h-full min-h-[400px] items-center justify-center text-center lg:min-h-[auto]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                color: "text-slateus-300",
                                children: "loading..."
                            })
                        }), ()=>hasSeriesData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default()), {
                            highcharts: (highcharts__WEBPACK_IMPORTED_MODULE_1___default()),
                            options: options
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex h-full min-h-[400px] items-center justify-center text-center lg:min-h-[auto]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                color: "text-slateus-300",
                                children: "data unavailable"
                            })
                        })))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-wrap justify-between gap-x-4 gap-y-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UpdatedAgo__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        updatedAt: updatedAtFromSupplySeriesCollection(supplySeriesCollections, timeFrame)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EthSupplyWidget);


/***/ }),

/***/ 69857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ LONDON_TIMESTAMP; }
/* harmony export */ });
const LONDON_TIMESTAMP = new Date("2021-08-05T00:00:00Z");


/***/ })

}]);